import React from 'react'
// i18
import { useTranslation } from 'react-i18next'
// Layout
import { Navbar } from '../layout/Navbar'
import { Back } from '../layout/Back'
import { Session } from '../layout/Session'
// Fragments
import { BreadCrumb } from '../fragments/Send/BreadCrumb'
import { Form } from '../fragments/Send/Form'

export const SendTemplate = () => {
    const { t } = useTranslation(["translation"]);

    return (
        <section>
            <Navbar />
            <BreadCrumb t={t} />
            <Form t={t} />
            <Back />
            <Session />
        </section>
    )
}
